import { defineStore } from "pinia";
import { ref } from "vue";

export type FeedFilter =
  | "all"
  | "forYou"
  | "following"
  | "bookmarks"
  | "creators"
  | "groups"
  | "newUsers"
  | "songs"
  | "trending"
  | "trendingPosts"
  | "discover"
  | "popular"
  | "forYouMusic"
  | "new"
  | "timeline"
  | "videos"
  | "podcasts"
  | "bursts";

const LAST_FEED_KEY = "last-feed";

export const useAppModeStore = defineStore("appMode", () => {
  // Track last selected feed for back navigation
  const savedFeed = localStorage.getItem(LAST_FEED_KEY) as FeedFilter | null;
  const lastFeed = ref<FeedFilter>(savedFeed || "all");

  function setLastFeed(feed: FeedFilter) {
    lastFeed.value = feed;
    localStorage.setItem(LAST_FEED_KEY, feed);
  }

  return {
    lastFeed,
    setLastFeed,
  };
});
